export default function AccountLogoutController($scope, Users) {
    console.log("LOGUT HIT");
    // Users.logout();
}
